module.exports = "/_next/static/pages/remote-proctoring/2764a71f3110827855447c762561b157.png";